import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Playlist } from '@/components/Playlist';
import { ChevronRight } from 'lucide-react';

export function PlaylistArea({
  playlist,
  currentIndex,
  isPlaying,
  isPlaylistCollapsed,
  setIsPlaylistCollapsed,
  isStreamerMode,
  onFileUpload, 
  playSongAtIndex,
  removeSong,
  reorderSongs,
  handlePlayPause,
  forcePlay,
  forcePause,
  totalPlaylistDuration 
}) {
  console.log("PlaylistArea.jsx: Received totalPlaylistDuration prop:", totalPlaylistDuration);

  if (isStreamerMode) {
    return null;
  }

  const playlistWidth = isPlaylistCollapsed ? 48 : 320;

  return (
    <div 
      className="relative flex-shrink-0 transition-all duration-300 ease-in-out"
      style={{ width: playlistWidth }}
    >
      <AnimatePresence mode="wait">
        {!isPlaylistCollapsed ? (
          <motion.div 
            key="playlist-expanded"
            initial={{ x: -320, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -320, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="absolute inset-0 border-r flex flex-col transition-all duration-300 w-80 bg-black/20 backdrop-blur-sm border-white/10"
            style={{ width: 320 }}
          >
            <Playlist
              playlist={playlist}
              currentIndex={currentIndex}
              isPlaying={isPlaying}
              onFileUpload={onFileUpload} 
              onSongSelect={playSongAtIndex}
              onSongRemove={removeSong}
              onReorder={reorderSongs}
              onPlay={forcePlay}
              onPause={forcePause}
              isStreamerMode={isStreamerMode}
              onCollapse={() => setIsPlaylistCollapsed(true)}
              totalPlaylistDuration={totalPlaylistDuration} 
            />
          </motion.div>
        ) : (
          <motion.div
            key="playlist-collapsed"
            initial={{ x: -48, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -48, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="absolute inset-0 border-r flex items-center justify-center transition-all duration-300 w-12 bg-black/20 backdrop-blur-sm border-white/10"
            style={{ width: 48 }}
          >
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsPlaylistCollapsed(false)}
              className="text-white hover:bg-white/10 h-full w-full rounded-none"
            >
              <ChevronRight className="h-5 w-5" />
            </Button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}